(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  // ── ETMY: hover 触发下拉菜单 ──
  (function() {
    function initHoverMenus() {
      const allDetails = document.querySelectorAll('.header__inline-menu header-menu details');
      allDetails.forEach(function(details) {
        let closeTimer = null;
        function open() {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
          allDetails.forEach(function(other) { if (other !== details) other.removeAttribute('open'); });
          details.setAttribute('open', '');
        }
        function close() {
          closeTimer = setTimeout(function() { details.removeAttribute('open'); }, 200);
        }
        function cancelClose() {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        }
        const summary = details.querySelector('summary');
        if (summary) {
          summary.addEventListener('mouseenter', open);
          summary.addEventListener('mouseleave', close);
          summary.addEventListener('click', function(e) { e.preventDefault(); });
        }
        const submenu = details.querySelector('.header__submenu');
        if (submenu) {
          submenu.addEventListener('mouseenter', cancelClose);
          submenu.addEventListener('mouseleave', close);
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHoverMenus);
    } else {
      initHoverMenus();
    }
  })();

  // ── ETMY 即时搜索（独立实现） ──
  (function() {
    function initETMYSearch(wrap) {
      var input = wrap.querySelector('.etmy-search-input');
      var dropdown = wrap.querySelector('.etmy-predictive-dropdown');
      var defaultView = wrap.querySelector('.etmy-predictive-default');
      var resultsContainer = wrap.querySelector('.etmy-results-container');
      if (!input || !dropdown) return;

      var timer = null;
      var activeQuery = '';

      function show() { dropdown.style.display = 'block'; }
      function hide() { dropdown.style.display = 'none'; }

      function showDefault() {
        resultsContainer.innerHTML = '';
        defaultView.style.display = 'block';
        show();
      }

      function showResults(html) {
        defaultView.style.display = 'none';
        resultsContainer.innerHTML = html;
        show();
      }

      input.addEventListener('focus', function() {
        if (!input.value.trim()) showDefault();
        else if (resultsContainer.innerHTML) show();
      });

      input.addEventListener('input', function() {
        clearTimeout(timer);
        var q = input.value.trim();
        activeQuery = q;
        if (!q) { showDefault(); return; }
        timer = setTimeout(function() {
          fetch('/search/suggest?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product&resources[limit]=6')
            .then(function(r) { return r.text(); })
            .then(function(text) {
              if (q !== activeQuery) return;
              var doc = new DOMParser().parseFromString(text, 'text/html');
              var section = doc.querySelector('#shopify-section-predictive-search');
              if (section) showResults(section.innerHTML);
            })
            .catch(function() {});
        }, 300);
      });

      document.addEventListener('click', function(e) {
        if (!wrap.contains(e.target)) hide();
      });
    }

    function init() {
      document.querySelectorAll('.etmy-predictive-search').forEach(initETMYSearch);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
